import { useEffect, useState } from 'react'
import { useTheme } from '@emotion/react'
import useInterval from 'react-use/lib/useInterval'
import { text } from 'chaoskit/src/assets/styles/utility'

import {
  CounterWrapper,
  CounterDigit,
  CounterGroup,
  createTimeObject,
} from '~components/Counter'

const Counter = () => {
  const theme = useTheme()

  const [delay, setDelay] = useState(1000)
  const [time, setTime] = useState(0)
  const [timeObject, setTimeObject] = useState(createTimeObject(time))

  const adjustClock = () => {
    const nextTime = time + 1
    setTime(nextTime)

    setTimeObject(createTimeObject(nextTime))
  }

  useInterval(() => {
    adjustClock()
  }, delay)

  useEffect(() => {
    // Pause after 30 minutes
    if (time >= 1800) {
      setDelay(null)
    }
  }, [time])

  return (
    <CounterWrapper
      groupCount={2}
      css={{
        [theme.mq.small__max]: {
          justifyContent: 'center',
        },
      }}
    >
      <CounterGroup label="Minutes">
        <CounterDigit digit={timeObject.minutes.split('')[0]} />
        <CounterDigit digit={timeObject.minutes.split('')[1]} />
      </CounterGroup>
      <CounterGroup label="Seconds">
        <CounterDigit digit={timeObject.seconds.split('')[0]} />
        <CounterDigit digit={timeObject.seconds.split('')[1]} />
      </CounterGroup>
    </CounterWrapper>
  )
}

const Clock = (props) => {
  const theme = useTheme()

  return (
    <div
      css={{
        marginTop: theme.space.xlarge,
        marginBottom: theme.space.large,
      }}
      {...props}
    >
      <div
        css={{
          textAlign: 'center',
          ...theme.text.small,
          ...text.expanded(theme),
          fontWeight: theme.fontWeight.bold,
          marginBottom: theme.space.base,

          [theme.mq.medium]: {
            textAlign: 'left',
          },
        }}
      >
        Session Timer
      </div>
      <Counter />
    </div>
  )
}

export default Clock
